import { SubscriptionOffer } from '../../hooks/subscriptionOffer/interfaces'

export const sortByDuration = (a: SubscriptionOffer, b: SubscriptionOffer) =>
  a.duration - b.duration
